module.exports = __webpack_public_path__ + "img/filled.798ae4f4.svg";